import React, { useEffect, useState } from "react";

const getRemaining = (dateStr) => {
  if (!dateStr) return null;
  const target = new Date(`${String(dateStr).slice(0, 10)}T00:00:00`);
  if (isNaN(target.getTime())) return null;
  const diff = target.getTime() - Date.now();
  if (diff <= 0) return { expired: true };
  return {
    expired: false,
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff % 86400000) / 3600000),
    minutes: Math.floor((diff % 3600000) / 60000),
  };
};

const formatDateIt = (dateStr) => {
  const d = new Date(`${String(dateStr).slice(0, 10)}T00:00:00`);
  if (isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" });
};

// variant: "light" (white pages) | "dark" (black home theme) | "inline" (compact, product card)
export const PreorderCountdown = ({ preorderDate, variant = "light" }) => {
  const [rem, setRem] = useState(() => getRemaining(preorderDate));

  useEffect(() => {
    setRem(getRemaining(preorderDate));
    const t = setInterval(() => setRem(getRemaining(preorderDate)), 60000);
    return () => clearInterval(t);
  }, [preorderDate]);

  if (!rem) return null;

  if (rem.expired) {
    if (variant === "inline") {
      return <span className="text-orange-600 font-semibold" data-testid="preorder-countdown-expired">🚀 In arrivo a giorni!</span>;
    }
    return (
      <div className={variant === "dark" ? "text-orange-400 text-xs font-semibold" : "bg-orange-50 border border-orange-200 rounded-lg p-3 text-orange-800 font-medium"} data-testid="preorder-countdown-expired">
        🚀 In arrivo a giorni!
      </div>
    );
  }

  const units = [
    { v: rem.days, l: rem.days === 1 ? "giorno" : "giorni" },
    { v: rem.hours, l: "ore" },
    { v: rem.minutes, l: "min" },
  ];

  if (variant === "inline") {
    return (
      <span className="inline-flex items-center gap-1 text-orange-600 font-semibold" data-testid="preorder-countdown">
        ⏳ Arriva tra {rem.days > 0 ? `${rem.days} ${units[0].l}` : `${rem.hours}h ${rem.minutes}m`}
      </span>
    );
  }

  if (variant === "dark") {
    return (
      <div className="flex items-center gap-2 mt-1" data-testid="preorder-countdown">
        <span className="text-blue-400 text-[10px] font-bold uppercase tracking-wider">⏳ Arriva tra</span>
        <div className="flex gap-1">
          {units.map((u) => (
            <span key={u.l} className="bg-blue-500/15 border border-blue-500/30 text-blue-300 text-[10px] font-extrabold px-1.5 py-0.5 rounded">
              {u.v} {u.l}
            </span>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="bg-orange-50 border border-orange-200 rounded-lg p-3" data-testid="preorder-countdown">
      <p className="text-orange-800 font-medium mb-2">📅 Disponibile dal {formatDateIt(preorderDate)}</p>
      <div className="flex items-center gap-2">
        <span className="text-orange-600 text-xs font-bold uppercase tracking-wider">⏳ Arriva tra</span>
        {units.map((u) => (
          <div key={u.l} className="bg-white border border-orange-300 rounded-md px-2.5 py-1 text-center shadow-sm">
            <span className="text-orange-700 font-extrabold text-lg leading-none">{u.v}</span>
            <span className="text-orange-500 text-[10px] font-semibold uppercase block">{u.l}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PreorderCountdown;
